import { Descriptions, Heading } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { startCase } from 'lodash'
import { useTranslation } from 'react-i18next'
import {
  DATE_FORMAT,
  getDateTimeInZone,
  getTimeInZone,
  TIME_FORMAT
} from 'screens/Rostering/utils.datetime'
import styled from 'styled-components'

type RecurrencePatternProps = {
  pattern?: any
}

const RecurrencePattern = ({ pattern }: RecurrencePatternProps) => {
  const { t } = useTranslation()

  const list = [
    {
      key: `frequency`,
      label: <Text>{t('FREQUENCY')}</Text>,
      children: <Text>{startCase(pattern.frequencyDescription)}</Text>
    },
    {
      key: `startDate`,
      label: <Text>{t('START_DATE')}</Text>,
      children: (
        <Text>
          {getDateTimeInZone(pattern.patternStart)?.format(DATE_FORMAT)}
        </Text>
      )
    },
    {
      key: `endDate`,
      label: <Text>{t('END_DATE')}</Text>,
      children: (
        <Text>
          {pattern.patternEnd
            ? getDateTimeInZone(pattern.patternEnd)?.format(DATE_FORMAT)
            : '-'}
        </Text>
      )
    },
    {
      key: `timeWindow`,
      label: <Text>{t('TIME_WINDOW')}</Text>,
      children: (
        <Text>
          {getTimeInZone(pattern.startTime).format(TIME_FORMAT)} -{' '}
          {getTimeInZone(pattern.endTime).format(TIME_FORMAT)}
        </Text>
      )
    },
    {
      key: `duration`,
      label: <Text>{t('PLANNED_DURATION')}</Text>,
      children: <Text>{pattern.expectedDuration}</Text>
    }
  ]

  return (
    <MainWrapper>
      <TopWrapper>
        <InfoWrapper>
          <TitlesWrapper>
            <Heading level={3}>{t('RECURRENCE_PATTERN')}</Heading>
          </TitlesWrapper>
        </InfoWrapper>
      </TopWrapper>
      <DescWrapper>
        <Descriptions
          labelStyle={labelStyle}
          items={list}
          bordered
          column={1}
          layout="horizontal"
        />
      </DescWrapper>
    </MainWrapper>
  )
}

const labelStyle = { width: 150 }

const TitlesWrapper = styled.div`
  margin-left: 8px;
  display: flex;
  flex-direction: column;
`

const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.color.neutral.color11};
  padding: 24px;
  border-radius: ${(props) => props.theme.properties.borderRadius.large};
  flex: 1;
`

const TopWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const DescWrapper = styled.div`
  border-top: 1px solid;
  border-color: ${(props) => props.theme.color.neutral.color8};
  padding-top: 16px;
  margin-top: 16px;
`

export default RecurrencePattern
